import { getLocaleDateFormat, registerLocaleData } from '@angular/common';
import localeHu from '@angular/common/locales/hu';
import { Injectable } from '@angular/core';
import { formatMessage, loadMessages, formatDate, parseDate, locale } from 'devextreme/localization';
import huMessages from 'devextreme/localization/messages/hu.json';
import { enDictionary, huDictionary } from '../dictionaries';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  language = localStorage.getItem('hatLanguage') || 'hu';
  languages = ['hu', 'en'];

  constructor() {}

  initLanguage(): void {
    registerLocaleData(localeHu);
    loadMessages(huMessages);
    loadMessages(enDictionary);
    loadMessages(huDictionary);
    locale(this.language);
    localStorage.setItem('hatLanguage', this.language);
  }

  changeLanguage(lang: string): void {
    this.language = lang;
    locale(this.language);
    localStorage.setItem('hatLanguage', this.language);
    window.location.reload();
  }

  get(message: string, values: string[] = []): string {
    return formatMessage(message, ...values);
  }

  getDateDisplayFormat(date: Date, lang: string): string {
    console.debug('I got this as Date: ', date)

    const dateFormat = (lang === 'hu') ? "yyyy.MM.dd" : "dd.MM.yyyy"
    return formatDate(date, dateFormat)
  }

  getParsedDate(strDate: string) {
    return parseDate(strDate, "yyyy-MM-dd");
  }

}
